// extracted by mini-css-extract-plugin
export default {"modalBg":"BoxSelectionModal_modalBg__4adc8","modalScrollable":"BoxSelectionModal_modalScrollable__a++Gk"};